import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { NoSpacesDirective } from '../../../_directives/no-space.directive';
import { JsEmail } from '../../../_interfaces/email.interface';

export interface CloneDialogData {
  sourceTemplate: JsEmail;
}

export interface CloneDialogResult {
  templateName: string;
  description: string;
}

@Component({
  selector: 'app-email-clone-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatError,
    MatInput,
    MatIcon,
    NoSpacesDirective,
  ],
  templateUrl: './email-clone-dialog.component.html',
  styleUrl: './email-clone-dialog.component.scss',
})
export class EmailCloneDialogComponent {
  cloneForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EmailCloneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CloneDialogData,
    private fb: FormBuilder
  ) {
    this.cloneForm = this.fb.group({
      templateName: new FormControl('', [
        Validators.required,
        Validators.max(50),
        Validators.maxLength(50),
      ]),
      description: new FormControl(data.sourceTemplate.description || ''),
    });
  }

  hasChanges(): boolean {
    return this.cloneForm.valid && this.cloneForm.value.templateName.trim() !== '';
  }

  cancel(): void {
    this.dialogRef.close();
  }

  clone(): void {
    if (this.cloneForm.valid) {
      const result: CloneDialogResult = {
        templateName: this.cloneForm.value.templateName.trim(),
        description: this.cloneForm.value.description.trim(),
      };
      this.dialogRef.close(result);
    }
  }
}
